import { render } from "./SalesProformaReport.vue?vue&type=template&id=c6e43e4a"
import script from "./SalesProformaReport.vue?vue&type=script&lang=js"
export * from "./SalesProformaReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__